import React from 'react';
import Divider from './divider';

const MenuWrapper = ({ children }) => (
  <div className="ws-ui-editor-header__menu-wrapper">
    {children}
    <Divider />
  </div>
);

export default MenuWrapper;
